import { DatePipe } from '@angular/common';
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { FinishedProductModel, FinishedProductStatus } from '../../../../@models/erp/finishedProduct';
import { DocumentSelectComponent } from './document-select.component';

@Component({
  selector: 'ngx-document-finished-product-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentFinishedProductSelectorComponent extends DocumentSelectComponent implements OnChanges {

  paginationId = 'documentFinishedProductSelectorPagination';

  baseProducts: any;

  constructor(private datePipe: DatePipe, public api: ApiService, public data: SharedDataService) {
    super(data);
    this.showBusinessInput = true;
    this.title = 'Finished Products';
  }

  async ngOnInit() {
    await this.data.loadProducts();
    this.baseProducts = Object.fromEntries(new Map(this.data.baseProducts.map(m => [m._id, m]))); // _id based dictionary
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.businessId?.currentValue) {
      this.onBusinessIdChanged(changes.businessId.currentValue);
    }
  }

  onBusinessIdChanged(id: string) {
    this.businessId = id;
    if (this.businessId) {
      this.showPagination = false;
    } else {
      this.showPagination = true;
    }
    this.init();
  }

  init() {
    // this.style = { width: '70em', left: '-20em' };
    this.initialItems = this.data.finishedProducts;
    if (this.businessId) {
      this.initialItems = this.data.finishedProducts?.filter(f => {
        const customers = Array.isArray(f.customers) ? f.customers : [f.customers]; // legacy
        const suppliers = Array.isArray(f.suppliers) ? f.suppliers : [f.suppliers];
        const businesses = [...customers, ...suppliers].map(m => m && mongoId(m.id));
        return !f.draft && (f.allCustomers || f.allSuppliers || businesses.includes(this.businessId))
      }
      );
    }
    this.latestVersionItems = [...this.initialItems].filter(f => this.showDisabled || !(f as FinishedProductModel).disabled);
    this.onFilter();
  }

  columns = [
    { id: 'calcName', title: 'NRK product name', search: '' },
    { id: 'calcCode', title: 'NRK code', search: '' },
    { id: 'content', title: 'Dimensions', search: ''},
    { id: 'product', title: 'Base product', search: ''},
    { id: 'trial', title: 'Trial #', search: ''},
    { id: 'externalCode', title: 'Customer code', search: ''},
    { id: 'status', title: 'Status', search: ''},
  ]

  getText(col: string, item: FinishedProductModel) {
    if (!item) return '';
    switch (col) {
      case 'content': return this.data.getFinishedProductDimensions(item) || '';
      case 'product': return this.baseProducts[mongoId(item.product)]?.name || '';
      case 'trial': return this.baseProducts[mongoId(item.product)]?.trial || '';
      case 'status': return FinishedProductStatus.getOptions().find(f => f.id === item.status)?.name;
      default: return item[col];
    }
  }

}

